var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { NotifyClient } from '@juvare/platform-sdk-js/NotifyClient';
import { AlertBaseClient } from './AlertBaseClient';
/**
 * @deprecated all new code needs to go to `AlertServiceClient.ts`.
 */
class ContextClient extends AlertBaseClient {
    constructor(baseUrl) {
        const notifyClient = new NotifyClient();
        super({ onTokenRequest: () => notifyClient.getAlertToken().then((result) => result.token) }, baseUrl);
        this.getChannels = () => __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance({
                method: 'GET',
                url: `/v1/context/channels?cacheBust=${Date.now()}`,
            });
            return response.data;
        });
        this.getOwners = () => __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance({
                method: 'GET',
                url: `/v1/context/owners?cacheBust=${Date.now()}`,
            });
            return response.data;
        });
        this.getUser = () => __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance({
                method: 'GET',
                url: `/v1/context/user?cacheBust=${Date.now()}`,
            });
            return response.data;
        });
    }
}
export default ContextClient;
